import { NgModule } from '@angular/core';
import { FilterTrainsBySitePipe } from './filter-trains-by-site/filter-trains-by-site';
import { AbsoluteValuePipe } from './absolute-value/absolute-value';
import { YearFilterPipe } from './year-filter/year-filter';
import { NotificationsPipe } from './notifications/notifications';
import { MonthPipe } from './month/month';
import { FavoritesPipe } from './favorites/favorites';
import { StartsPipe } from './starts/starts';
import { TagsSearchPipe } from './tags-search/tags-search';
import { OrderByPipe } from './orderBy/orderByPipe';


@NgModule({
 declarations: [FilterTrainsBySitePipe,
    AbsoluteValuePipe,
    YearFilterPipe,
    OrderByPipe,
    NotificationsPipe,
    MonthPipe,
  FavoritesPipe,
    StartsPipe,
    TagsSearchPipe,
    ],
    imports: [],
    exports: [FilterTrainsBySitePipe,
    AbsoluteValuePipe,
    YearFilterPipe,
    OrderByPipe,
    NotificationsPipe,
    MonthPipe,
  FavoritesPipe,
    StartsPipe,
    TagsSearchPipe,
  ]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts